<template>
    <div class="dock-fm-icon">
        <svg class="dock-fm-svg" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect class="dock-fm-doc dock-fm-doc--back" x="41" y="16" width="54" height="68" rx="6"/>
            <rect class="dock-fm-doc dock-fm-doc--mid" x="33" y="26" width="54" height="68" rx="6"/>
            <rect class="dock-fm-doc dock-fm-doc--front" x="25" y="36" width="54" height="68" rx="6"/>
            <line class="dock-fm-line" x1="37" y1="56" x2="67" y2="56"/>
            <line class="dock-fm-line" x1="37" y1="67" x2="61" y2="67"/>
            <line class="dock-fm-line" x1="37" y1="78" x2="53" y2="78"/>
        </svg>
        <span v-if="showBadge && uploadingCount > 0" class="dock-fm-badge">{{ uploadingCount > 99 ? '99+' : uploadingCount }}</span>
    </div>
</template>

<script>
import fileManagerService from './fileManagerService'

export default {
    name: 'DockFileManagerIcon',
    mounted() {
        fileManagerService.restoreSettings()
    },
    computed: {
        showBadge() {
            return fileManagerService.state.dockBadge
        },
        uploadingCount() {
            return fileManagerService.state.uploadQueue.filter(u => u.status === 'uploading').length
        },
    },
}
</script>

<style scoped>
.dock-fm-icon {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(145deg, #4A9EF7 0%, #2563EB 60%, #1D4ED8 100%);
    border-radius: 22.5%;
    overflow: visible;
}

.dock-fm-icon span {
    display: block;
}

.dock-fm-svg {
    width: 82%;
    height: 82%;
}

.dock-fm-doc {
    stroke: rgba(255, 255, 255, 0.2);
    stroke-width: 0.5;
}

.dock-fm-doc--back {
    fill: rgba(255, 255, 255, 0.55);
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
}

.dock-fm-doc--mid {
    fill: rgba(255, 255, 255, 0.75);
    filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.12));
}

.dock-fm-doc--front {
    fill: #fff;
    filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.15));
}

.dock-fm-line {
    stroke: rgba(37, 99, 235, 0.35);
    stroke-width: 3.5;
    stroke-linecap: round;
}

.dock-fm-badge {
    --_icon: var(--dock-icon-size, 48px);
    --_h: calc(var(--_icon) * 0.42);
    display: flex !important;
    position: absolute;
    top: calc(var(--_h) * -0.3);
    right: calc(var(--_h) * -0.25);
    min-width: var(--_h);
    height: var(--_h);
    border-radius: calc(var(--_h) / 2);
    font-size: calc(var(--_icon) * 0.21);
    background: #EF4444;
    color: #fff;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    line-height: 1;
    padding: 1.4px 0 0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
    pointer-events: none;
    z-index: 1;
    transition: min-width 0.12s ease-out, height 0.12s ease-out, font-size 0.12s ease-out, top 0.12s ease-out, right 0.12s ease-out;
}
</style>
